import { ERROR_INFORMATION_CREDIT } from '../actions';

const INIT_STATE = {
    informationCredit: null,
};

const errorsReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case ERROR_INFORMATION_CREDIT:
            return { ...state, informationCredit: action.payload };
        default:
            return { ...state };
    }
};

export default errorsReducer;
